import { render, staticRenderFns } from "./WebLinkDefault.vue?vue&type=template&id=f9bd877a&scoped=true&"
import script from "./WebLinkDefault.vue?vue&type=script&lang=js&"
export * from "./WebLinkDefault.vue?vue&type=script&lang=js&"
import style0 from "./WebLinkDefault.vue?vue&type=style&index=0&id=f9bd877a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bd877a",
  null
  
)

export default component.exports